import React, { Component } from "react";

class FormGroupTextField extends Component {
  render() {
    const { label, width, name, textarea, value, error, ...rest } = this.props;

    return (
      <div className={"form-group col-md-" + width}>
        <span className="form-label font-weight-bolder">{label}</span>
        {!textarea && (
          <input
            className={"form-control" + (value === "" ? " text-muted" : "") + (error ? " is-invalid" : "")}
            value={value}
            {...rest}
            onChange={this.onTextChange}
          />
        )}
        {textarea && (
          <textarea
            className={"form-control " + (error ? "is-invalid" : "")}
            value={value}
            {...rest}
            onChange={this.onTextChange}
          />
        )}
      </div>
    );
  }

  onTextChange = event => {
    this.props.onChange(this.props.name, event.target.value);
  };
}

FormGroupTextField.defaultProps = {
  width: "6",
  type: "text"
};

export default FormGroupTextField;



// WEBPACK FOOTER //
// ./src/views/components/formGroupField.js